module.exports = __webpack_public_path__ + "static/outside_dark-25d18865f2b6f09220049a8a4b7e5d4f.jpg";